 
export default {
  baseStyle: {
    fontWeight: "400",
    _active: {
      color: "primary.500",
    },
  },
  variants: {
    solid: {
      border: "1px solid transparent",
      _hover: {
        borderColor: "secondary",
        bg: "secondary",
      },
    },
    link: {
      border: "none",
      _hover: {
        border: "none",
      },
    },
  },
};
